import { Translation } from '@ps/web-shared-components';
import React from 'react';

import StepOne from '../../../../assets/icons/activestep1.svg';
import FutureStepTwo from '../../../../assets/icons/futurestep2.svg';
import FutureStepThree from '../../../../assets/icons/futurestep3.svg';
import FutureStepBonus from '../../../../assets/icons/futurestepbonus.svg';

import { TXTWCL_Account_details } from './StepOneActive.messages.json';

interface StepOneActiveProps {
  classname: string;
  hideBonusIcon?: boolean;
}

const StepOneActive = ({ classname, hideBonusIcon }: StepOneActiveProps) => (
  <>
    <div className={classname}>
      <StepOne />
      <p>
        <Translation {...TXTWCL_Account_details} />
      </p>
    </div>
    <FutureStepTwo />
    <FutureStepThree />
    {!hideBonusIcon && <FutureStepBonus />}
  </>
);

export default StepOneActive;
